import { useEffect, useState } from "react";

import {
  getActiveWorkspaceId,
  setActiveWorkspaceId,
} from "../utils/workspaceStorage";

import { useWorkspaces } from "./useWorkspaces";

export const useWorkspaceInit = () => {
  const [showWorkspaceSwitcher, setShowWorkspaceSwitcher] = useState(false);
  const { data: workspacesData, isLoading } = useWorkspaces();

  useEffect(() => {
    if (
      isLoading ||
      !workspacesData?.workspaces ||
      workspacesData.workspaces.length === 0
    ) {
      return;
    }

    const existingWorkspaceId = getActiveWorkspaceId();

    if (!existingWorkspaceId) {
      const activeWorkspace = workspacesData.workspaces.find((w) => w.active);

      if (activeWorkspace) {
        setActiveWorkspaceId(activeWorkspace.id);
      } else {
        setShowWorkspaceSwitcher(true);
      }
    } else {
      const workspaceExists = workspacesData.workspaces.some(
        (w) => w.id === existingWorkspaceId,
      );
      if (!workspaceExists) {
        setActiveWorkspaceId("");
        setShowWorkspaceSwitcher(true);
      }
    }
  }, [workspacesData, isLoading]);

  return {
    showWorkspaceSwitcher,
    isInitializing: isLoading,
  };
};
